/**
 * Maakt van een Firestore-foutcode bij het ophalen van het inlogprofiel een
 * zin die op het scherm kan.
 *
 * WAAROM DEZE BESTAAT. Het inlogscherm ving de mislukte read wel netjes op,
 * maar zette voor élke oorzaak dezelfde zin neer en gooide de foutcode weg —
 * die ging alleen naar `console.error`, waar geen gebruiker kijkt. Daardoor
 * waren drie totaal verschillende storingen niet uit elkaar te houden:
 *
 * - `unavailable` — de browser bereikt Firestore niet. Inloggen lukt dan wél,
 *   want dat loopt over een gewone HTTPS-aanvraag; Firestore gebruikt een
 *   openstaande streamverbinding die bedrijfsproxy's, virusscanners die HTTPS
 *   openbreken en sommige privacy-extensies kapotmaken. Zie de terugvalstand
 *   `experimentalAutoDetectLongPolling` in `src/firebase/config.js`.
 * - `permission-denied` / `unauthenticated` — de sessie is niet meer geldig.
 *   'Opnieuw proberen' blijft daar eindeloos op hangen; uitloggen lost het op.
 * - al het andere.
 *
 * Elke tak noemt de code, ook de takken die we herkennen. Een schermafbeelding
 * van een vastgelopen gebruiker is daarmee genoeg om te weten wat er speelt —
 * dat was precies wat er ontbrak bij de melding van Duurzame Vecht
 * (2026-09-23). Zelfde opzet als `loginMessage` en `resetPasswordMessage`.
 *
 * @param {string | undefined | null} code - Firestore-foutcode, bijv. 'unavailable'
 * @returns {string} De melding in het Nederlands, nooit leeg, altijd mét de code
 */
const profileFetchMessage = (code) => {

    // Geen code is zelf ook een aanwijzing (een fout die niet van Firestore
    // komt), dus die krijgt een eigen woord in plaats van een lege haakjes.
    const kenmerk = code || 'onbekende fout'

    const staart = ` Blijft het misgaan, neem dan contact op met Deccos via info@deccos.nl en noem deze code: ${kenmerk}.`

    switch (code) {
        case 'unavailable':
        case 'deadline-exceeded':
            // Bewust niet 'probeer opnieuw in te loggen': het wachtwoord is
            // hier nooit het probleem, en opnieuw inloggen lukt gewoon —
            // waarna de gebruiker op exact dezelfde muur stuit.
            return 'Inloggen is gelukt, maar je gegevens konden niet worden opgehaald: er is geen verbinding.'
                + ' Dat ligt meestal aan het netwerk waar je op zit — een bedrijfsnetwerk, een virusscanner of'
                + ' een browserextensie kan dit blokkeren. Probeer een ander netwerk, bijvoorbeeld je telefoon.'
                + staart

        case 'permission-denied':
        case 'unauthenticated':
            return 'Inloggen is gelukt, maar je sessie is niet meer geldig, dus je gegevens konden niet worden'
                + " opgehaald. Klik op 'Uitloggen' en log daarna opnieuw in."
                + staart

        default:
            return 'Inloggen is gelukt, maar je gegevens konden even niet worden opgehaald.'
                + ' Probeer het zo nog eens.'
                + staart
    }
}

export default profileFetchMessage
